import cache from "./cachedState";
import Vue from "vue";

let state = {
  mode: "",
  group: false,
  table: "",
  items: [],
  groupCart: {}
};

const cachedStateId = "vuex-cart";
var cachedState = cache.load(cachedStateId);
if (cachedState) {
  state = JSON.parse(cachedState);
}
const saveCart = function(state) {
  cache.save(cachedStateId, JSON.stringify(state));
};

let actions = {};

let getters = {
  isCartShared: state => {
    return state.mode === "dine-in" && state.group && state.table.length > 4;
  },

  getCountByItemId: state => id => {
    if (!state.items) {
      return 0;
    }
    var item = state.items.find(item => item.id === id);
    if (item) {
      return item.qty;
    }
    return 0;
  },

  getBasketCount: state => {
    if (!state.items) {
      return 0;
    }
    var c = 0;
    state.items.forEach(i => {
      c += i.qty;
    });
    return c;
  },

  getBasketAmount: state => {
    var c = 0;
    state.items.forEach(i => {
      c += i.price * i.qty;
    });
    return c;
  }
};

let mutations = {
  setOrderMode(state, mode) {
    state.mode = mode;
    saveCart(state);
  },

  setEnableGroup(state, group) {
    state.group = group;
    saveCart(state);
  },

  setTable(state, table) {
    state.table = table;
    saveCart(state);
  },

  addItem(state, order) {
    // find existing first
    var i = state.items.find(i => i.id == order.item.id);
    if (!i) {
      i = {
        id: order.item.id,
        name: order.item.name,
        price: order.item.price,
        qty: 0
      };
      state.items.push(i);
    }
    i.qty = i.qty + order.qty;

    saveCart(state);
  },

  removeItem(state, order) {
    var i = state.items.find(i => i.id == order.item.id);
    if (!i) {
      return;
    }
    i.qty = i.qty - order.qty;
    if (i.qty < 0) {
      i.qty = 0;
    }

    saveCart(state);
  },

  updateGroupCart(state, data) {
    if (!state.groupCart) {
      Vue.set(state, "groupCart", {});
    }

    if (!data.user.email) {
      return;
    }

    delete state.groupCart[data.user.email];
    Vue.set(state.groupCart, data.user.email, data.cart);
    saveCart(state);
  }
};

export default {
  name: "cart",
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
